import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LogOut, Moon, Sun } from 'lucide-react'
import { cn } from '../layout.component'
import { BellIcon, ChevronDown, QuestionIcon } from '../../../assets'
import { useTheme } from '../../../contexts/theme.context'
import { useAuth } from '../../../contexts/auth.context'
import { useOutsideClick } from '../../../hooks/useOutsideClick.hook'

const Header = () => {
  const navigate = useNavigate()
  const { theme, toggleTheme } = useTheme()
  const { user, logout } = useAuth()
  const [profileOpen, setProfileOpen] = useState(false)
  const profileRef = useRef<HTMLDivElement>(null)

  const displayName = user?.full_name || user?.email?.split('@')[0] || 'Пользователь'
  const avatarLetter = displayName.charAt(0).toUpperCase()

  useOutsideClick(profileRef, () => setProfileOpen(false))

  const clearLocalStorage = () => {
    localStorage.removeItem('IS_FIRST_VISIT')
    window.location.reload()
  }

  const handleLogout = () => {
    setProfileOpen(false)
    logout()
    navigate('/')
  }

  return (
    <div className={cn('header')}>
      <select name="lang" id="lang" className={cn('lang-select')}>
        <option value="ru">Ru</option>
        <option value="kz">Kz</option>
      </select>

      <div className={cn('header__theme-toggle')} onClick={toggleTheme}>
        {theme !== 'light' ? <Sun size={18} strokeWidth={2} /> : <Moon size={18} strokeWidth={2} />}
      </div>

      <div className={cn('header__notifications')}>
        <div className={cn('header__notification')} onClick={clearLocalStorage}><QuestionIcon /> </div>
        <div className={cn('header__notification')}><BellIcon /> </div>
      </div>

      <div className={cn('header__profile-wrap')} ref={profileRef}>
        <button
          type="button"
          className={cn('header__profile', { open: profileOpen })}
          onClick={() => setProfileOpen((prev) => !prev)}
          aria-expanded={profileOpen}
          aria-haspopup="menu"
        >
          <div className={cn('header__profile-info')}>
            <div className={cn('header__profile-avatar')}>{avatarLetter}</div>
            <div className={cn('header__profile-name')}>{displayName}</div>
          </div>
          <ChevronDown className={cn('header__profile-chevron', { open: profileOpen })} />
        </button>

        {profileOpen && (
          <div className={cn('header__profile-menu')} role="menu">
            {user?.email && (
              <div className={cn('header__profile-menu-email')}>{user.email}</div>
            )}
            <button
              type="button"
              className={cn('header__profile-menu-item')}
              role="menuitem"
              onClick={handleLogout}
            >
              <LogOut size={16} strokeWidth={2} />
              Выйти
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Header
